export { default as Filters } from './Filters';
export { default as FiltersActive } from './FiltersActive';
export { default as RequireAllToggle } from './RequireAllToggle';
export { default as SavedFilters } from './SavedFilters';

export {
  FiltersProvider,
  useAppliedFilterParams,
  useFiltersContext,
  useFiltersDispatch
} from './FilterContext';

import type { FilterTypes } from 'shared-types';
import type { IconProp } from 'components/common/icons/Icon';

type FilterItemAttributes = {
  allowMultiple?: boolean;
  field: string;
  icon?: IconProp;
  items?: {
    subItems?: {
      label: string;
      value: string;
    }[];
    subItemsAll?: {
      label: string;
      value: string;
    };
    label: string;
    labelSubtitle?: string | React.ReactNode;
    value: string;
  }[];
  itemsAll?: { label: string; value: string };
  selectAllOnClick?: boolean;
  title: string;
  input?: boolean;
};

export type FilterItem = FilterItemAttributes & {
  filters?: (FilterItemAttributes & {
    items?: Pick<FilterItemAttributes['items'][0], 'label' | 'value'>[];
  })[];
};

export type FilterState = Partial<
  Record<Exclude<FilterTypes, 'userAttributes'>, { [value: string]: true }> & {
    presentInAll: { [value: string]: true };
  } & {
    [key: string]: { [value: string]: true };
  }
>;
